"use client";

import { forwardRef } from "react";
import type { HTMLAttributes, PropsWithChildren } from "react";
import Head from "next/head";
import cn from "classnames";

import styles from "./ImgBgResponsive.module.scss";

interface ImgBgResponsiveRenderProps extends HTMLAttributes<HTMLElement> {
  imageUrl: string;
  lazy?: "eager" | "lazy";
  prefetch?: boolean;
  loadImage: boolean;
}

const ImgBgResponsiveRender = forwardRef<HTMLDivElement, PropsWithChildren<ImgBgResponsiveRenderProps>>(
  ({ lazy = "lazy", children, imageUrl, className, prefetch = true, style, loadImage, ...attrs }, ref) => {
    return (
      <>
        {prefetch && (
          <Head>
            <link
              rel="preload"
              href={imageUrl}
              as="image"
              fetchPriority={lazy === "eager" ? "high" : "low"}
            />
          </Head>
        )}
        <div
          ref={ref}
          style={{
            backgroundImage: loadImage || lazy === "eager" ? `url('${imageUrl}')` : "none",
            ...style,
          }}
          className={cn(className, styles.bgImg)}
          {...attrs}
        >
          {children}
        </div>
      </>
    );
  }
);

ImgBgResponsiveRender.displayName = "ImgBgResponsiveRender";

export default ImgBgResponsiveRender;
